<div class="main-content">
    <div class="quote-text">"{{chosenQuote.quote}}"</div>
    <div class="quote-by" [ngClass]="translate.currentLang"> - {{chosenQuote.by}} </div>
</div>

